import React, { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { canRetryRefinement, refinementMessage } from '../../utils/refinementDiagnostics';

export default function RefinementErrorAlert({ error, onRetry, disabled = false }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    setNow(Date.now());
    if (!error?.retryAt || error.retryAt <= Date.now()) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [error]);
  if (!error) return null;
  const seconds = Math.max(0, Math.ceil(((error.retryAt || 0) - now) / 1000));
  const retry = canRetryRefinement(error);
  return <Alert severity="error" sx={{ mb: 1 }} action={retry ? (
    <Button color="inherit" size="small" disabled={disabled || seconds > 0} onClick={() => {
      if (!disabled && (!error.retryAt || error.retryAt <= Date.now())) onRetry?.();
    }}>{seconds > 0 ? `Retry in ${seconds}s` : 'Retry'}</Button>
  ) : (
    <Button color="inherit" size="small" href="mailto:info@tikcare.co?subject=Scribe%20transcript%20refinement">Contact support</Button>
  )}>{refinementMessage(error)}</Alert>;
}
